// Items with no vendor are never folded onto another vendor's purchase order —
// they get one of their own, which the user has to assign a vendor to before it
// will save. Say so up front so an extra unassigned PO isn't a surprise.
export function unassignedItemsNotice(unassignedCount) {
  const count = Number(unassignedCount) || 0;
  if (count <= 0) return '';
  return ` ${count} item${count === 1 ? ' has' : 's have'} no vendor assigned — ${
    count === 1 ? 'it' : 'they'
  } will go on a separate purchase order for you to assign a vendor to.`;
}

// When a proposal can't become purchase orders yet, the server lists every
// reason at once, each with the fixes the app can offer (see
// backend/src/utils/convertToPoReadiness.js). Anything else is a plain error.
export function getConvertToPoBlockers(data) {
  return data?.code === 'convert_to_po_blocked' && Array.isArray(data.blockers)
    ? data.blockers
    : [];
}
